var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilWritingEditing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51.08,184h107M118.17,60.38l23.09,19.08M125,50.46,148.1,69.54m8.53-10.71C162,51.68,161,41.5,154.44,36.1s-16.14-4-21.46,3.18M81.86,159.21,58.68,140.05M82,159,54.39,170.45l4-31,73.86-99.17L155.9,59.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilWritingEditing);
export default __webpack_public_path__ + "static/media/PENCIL_WRITING_EDITING.6bbd69b4bd1dae565ff686d036e59b4e.svg";
export { ForwardRef as ReactComponent };